/* eslint-disable max-len */
import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Tab, TabPanel } from "@similarweb/ui-components";

import { ButtonWrapper, StyledBox } from "app/components/React/WidgetContainer/styledComponents";
import { BacklinksOverviewSingleMetricWidgetContainer } from "app/pages/digital-marketing/backlinks/reports/overview/components/SingleMetricWidget/BacklinksSingleMetricWidgetStyledComponents";
import { BacklinksBodyContainer } from "app/pages/digital-marketing/backlinks/shared/BacklinksStyledComponents";
import { ChartContainer } from "app/pages/segments/mmx/styledComponents";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BacklinksOverviewBodyContainer = styled(BacklinksBodyContainer)`
    gap: 24px;
`;

export const WidgetsRow = styled(FlexRow)`
    gap: 24px;
`;

export const BacklinksOverviewBottomWidgetContainer = styled(FlexColumn)`
    min-width: 225px;
    width: 100%;
    gap: 8px;
`;

export const BacklinksOverviewTopWidgetsEmptyContainer = styled(FlexRow)`
    padding: 16px;
    width: 100%;
`;

export const BacklinksOverviewTopWidgetsContainer = styled(FlexRow)`
    width: 100%;
    min-height: 92px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    border-radius: 6px;
    ${BacklinksOverviewSingleMetricWidgetContainer}:not(:last-child) {
        border-right: 1px solid ${colorsPalettes.carbon[100]};
    }
`;

export const BacklinksChartBoxContainer = styled.div`
    width: 100%;
    [role="tab"]:last-of-type {
        border-right: none;
    }
    [role="tab"]:first-of-type {
        border-left: none;
    }
    ${ChartContainer} {
        padding: 0;
    }
    .value {
        ${setFontVariant("h3", colorsPalettes.carbon[400])};
    }
    ${ButtonWrapper} {
        margin-left: 0;
    }
    ${StyledBox} {
        height: 100%;
    }
`;

export const BacklinksChartContainer = styled.div`
    padding: 16px;
    height: 330px;

    > div > div {
        padding: 10px 0 0;
    }
`;

export const OvertimeChartSummaryRowContainer = styled(FlexRow)`
    padding: 16px 29px;
    gap: 4px;
`;

export const StyledTab = styled(Tab)`
    text-transform: none;
`;

const TabPanelStyled = styled(TabPanel)`
    padding: 16px;
`;
